import { render, staticRenderFns } from "./openstreetmap.vue?vue&type=template&id=21e89258&"
import script from "./openstreetmap.vue?vue&type=script&lang=js&"
export * from "./openstreetmap.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('21e89258')) {
      api.createRecord('21e89258', component.options)
    } else {
      api.reload('21e89258', component.options)
    }
    module.hot.accept("./openstreetmap.vue?vue&type=template&id=21e89258&", function () {
      api.rerender('21e89258', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2t3MNNoTPJ676/JS/comp/openstreetmap.vue"
export default component.exports